import './ProjectItemViewPopup.scss';
import React, { useEffect, useState } from 'react';
import Rodal from '../../../components/Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import moment from 'moment';
import { useStateSelector } from '../../../store/selectors';
import { DataRequestProject } from '../../../models/DataRequestHub/DataRequestProject';
import createNotification from '../../../utils/createNotification';
import { LinkedDataRequestProject } from '../../../slices/marketplace/timeline/models/linked-data-request-project.model';
import ProjectItemViewComponent from './ProjectItemViewComponent/ProjectItemViewComponent';
import Helpers from '../../../utils/helper';
import { initializeDataRequestNotifications } from '../../../models/DataRequestHub/slices/thunks/initialize-data-request-notifications.thunk';
import { useDispatch } from 'react-redux';
import { useCurrentMarketplaceParty } from '../../../custom-hooks/useCurrentMarketplaceParty';
import { TimelineParty } from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { Timeline } from '../../../slices/marketplace/timeline/models/timeline.model';
import { TimelineEvent } from '../../../slices/marketplace/timeline/models/timeline-event.model';
import { EngagementData } from '../../../slices/marketplace/timeline/models/engagement-data.model';
import { DocumentDetails } from '../../../slices/marketplace/timeline/models/document-details.model';
import { EngagementDocument } from '../../../slices/marketplace/timeline/models/engagement-document';

interface ProjectItemViewPopupProps {
    isVisible: boolean;
    setIsVisible(value: boolean): void;
    engagementStartDate: Date;
    questionnaireDocument: EngagementDocument;
    linkedProject: LinkedDataRequestProject;
}

const ProjectItemViewPopup = (props: ProjectItemViewPopupProps) => {
    const axios = useStateSelector((state) => state.core.axios);
    const dispatch = useDispatch() as any;
    const party = useCurrentMarketplaceParty();

    const [project, setProject] = useState<DataRequestProject>();

    const [loading, setIsLoading] = useState(true);

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    useEffect(() => {
        fetchProjectData(props.linkedProject.dataRequestProjectId);
    }, []);

    const initializeQuestionsSeenStatus = (projects: DataRequestProject[]) => {
        dispatch(
            initializeDataRequestNotifications({
                projects: projects,
                isAdminView: party === TimelineParty.VetValue,
            })
        );
    };

    const fetchProjectData = (projectId: number) => {
        setIsLoading(true);
        axios
            .get(`/api/dataRequestProjects/${projectId}`)
            .then((response) => {
                if (response.status === 200) {
                    setProject({ ...response.data });
                    initializeQuestionsSeenStatus([{ ...response.data }]);
                } else {
                    createNotification(
                        (response as any).response?.data?.detail ??
                            'An Error occured while fetching project data',
                        'error'
                    );
                }
            })
            .finally(() => setIsLoading(false));
    };

    const getHeaderDate = () => {
        let date = moment(new Date());

        if (props.questionnaireDocument && props.linkedProject) {
            date = moment(props.engagementStartDate).add(
                props.questionnaireDocument.datePosted,
                'days'
            );
        }

        return date.format('M/D/YYYY');
    };

    return (
        <Rodal
            visible={props.isVisible}
            onClose={() => props.setIsVisible(false)}
            animation="slideUp"
            className="project-item-view-popup"
            showMask={true}
            width={800}
            showCloseButton={true}>
            <ModalHeader>
                <div>
                    {`Practice Information Questionnaire - ${props.linkedProject.projectName}`}
                </div>{' '}
                <div>{`Date Posted - ${getHeaderDate()}`}</div>
            </ModalHeader>
            <ModalBody>
                {loading ? (
                    Helpers.renderLoader()
                ) : (
                    <div className="scroll-wrapper">
                        <ProjectItemViewComponent
                            project={project}
                            isReadonlyMode={true}
                            questionnaireDocument={props.questionnaireDocument}
                        />
                    </div>
                )}
            </ModalBody>
        </Rodal>
    );
};

export default ProjectItemViewPopup;
